const PDF_TOOL_FETCH = 'bfb/GP/PDF_TOOL_FETCH';
const PDF_TOOL_FETCH_SUCCEEDED = 'bfb/GP/PDF_TOOL_FETCH_SUCCEEDED';
const PDF_TOOL_FETCH_FAILED = 'bfb/GP/PDF_TOOL_FETCH_FAILED';
const PDF_TOOL_CLEAR = 'bfb/GP/PDF_TOOL_CLEAR';

export default {
  PDF_TOOL_FETCH,
  PDF_TOOL_FETCH_SUCCEEDED,
  PDF_TOOL_FETCH_FAILED,
  PDF_TOOL_CLEAR,
};
